"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownBeaconError = void 0;
const __1 = require("..");
class UnknownBeaconError extends __1.BeaconError {
    constructor() {
        super(__1.BeaconErrorType.UNKNOWN_ERROR, 'An unknown error occured. Please try again or report it to a developer.');
        this.name = 'UnknownBeaconError';
        this.title = 'Error';
    }
}
exports.UnknownBeaconError = UnknownBeaconError;
//# sourceMappingURL=UnknownBeaconError.js.map